import React, { useState, useEffect, useContext } from "react";
import {
  useQuery,
  useMutation,
  useManualQuery,
  ClientContext,
} from "graphql-hooks";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";

import {
  Container,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Header from "./Header.js";

import { GET_TERM_DATA_BY_TERM_UUID } from "../../graphQL/term_qry";
import { TERM_ALL_IN_SPRINT_PERIODS_QUERY } from "../../graphQL/termPeriod";
import { GET_ALL_TEAMS_IN_TERM_BY_ROLE_QUERY } from "../../graphQL/team_term_qry";
import { GET_ALL_MEMBERS_IN_TEAM_TERM_QUERY } from "../../graphQL/team_term_member_qry";
import { TEAM_TERM_ALL_PERIODS_QUERY } from "../../graphQL/team_term_period_qry";

import Diversity1Icon from "@mui/icons-material/Diversity1";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ActivitiesDialog from "./ActivitiesDialog.js";
import ResourcesDialog from "./ResourcesDialogFull.js";
import MemberAttendanceInfoDialog from "./MemberAttendanceInfoDialogFull.js";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";

import AlertDialog from "../../components/AlertDialog.js";
import { project_url } from "../../constants/Data";

const StyledTooltip = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -35px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7.2rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    paddingTop: 0,
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  dataGridStyle: {
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
    },

    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 14,
    },
  },
}));

const SprintDetail = () => {
  const { termUuid } = useParams();
  const classes = useStyles();
  const [loadContent, setLoadContent] = useState(false);
  const [loadData, setLoadData] = useState(false);

  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);

  const [termName, setTermName] = useState("");
  const [periodDataList, setPeriodDataList] = useState([]);
  const [teamsList, setTeamsList] = useState([]);
  const [sprintStartDate, setSprintStartDate] = useState(null); //first period in the current term that is in-sprint
  const [sprintEndDate, setSprintEndDate] = useState(null); //end date of the last period in the current term that is in-sprint.
  const [termData, setTermData] = useState([]);
  const [openActivitiesDialog, setOpenActivitiesDialog] = useState(null);
  const [openResourcesDialog, setOpenResourcesDialog] = useState(null);
  const [openAttendanceDialog, setOpenAttendanceDialog] = useState(null);
  const [noCurrentSprintFlg, setNoCurrentSprintFlg] = useState(null);
  const [activitiesRows, setActivitiesRows] = useState([]);
  const [getTermInSprintPeriodsQuery] = useManualQuery(TERM_ALL_IN_SPRINT_PERIODS_QUERY);
  const [getTermDataQuery] = useManualQuery(GET_TERM_DATA_BY_TERM_UUID, {
    fetchPolicy: "network-only",
  });
  const [fetchAllTermTeams] = useManualQuery(GET_ALL_TEAMS_IN_TERM_BY_ROLE_QUERY);
  const [fetchAllTeamTermResources] = useManualQuery(GET_ALL_MEMBERS_IN_TEAM_TERM_QUERY);
  const [fetchAllTeamTermPeriods] = useManualQuery(TEAM_TERM_ALL_PERIODS_QUERY);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => {
      console.log(err);
    },
  });

  
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  useEffect(() => {
    (() => getTermData())();
  }, []);

  useEffect(() => {
    (() => getTeamsList())();
  }, [termData]);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        navigate(`${project_url}/signin/?next=${pathname}`);
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin/?next=${pathname}`);
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem(
        "refreshToken",
        refreshData.refreshToken.refreshToken
      );
      client.setHeader(
        "Authorization",
        `JWT ${refreshData.refreshToken.token}`
      );
      setLoadContent(true);
    }
  };

  let email = localStorage.getItem("email") ? localStorage.getItem("email") : null;

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  let clientName = "";
  if (localStorage.getItem("clientName"))
    clientName = localStorage.getItem("clientName");

  const [viewAccess, setViewAccess] = useState(true);

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Sprints",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
        
            
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      
      
      if(commonActions.find(a => a == "View")){
        setViewAccess(true);}
      else {setViewAccess(false);}


      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }  
  
  const formatter1 = new Intl.DateTimeFormat("en-us", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    fractionalSecondDigits: 3,
    hour12: true,
    timeZoneName: "short",
  });

  const formatter2 = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = (day, format = null) => {
    const dayDate = new Date(day);
    const dayFormat =
      format !== null
        ? formatter1.formatToParts(dayDate)
        : formatter2.formatToParts(dayDate);
    if (format === "DDmonthYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "day").value +
        " " +
        dayFormat.find((a) => a.type == "month").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "monthDDYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "YYYYmonthDD") {
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value +
        ", " +
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value;
      return newFormat;
    } else {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        "/" +
        dayFormat.find((a) => a.type == "day").value +
        "/" +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    }
  };

  const getTeamsList = async () => {
    if (termData.termId) {
      const {
        loading: teamsListLoading,
        error: teamsListError,
        data: teamsListData,
      } = await fetchAllTermTeams({
        variables: {
          termId: parseInt(termData.termId),
          isTenantAdmin: isTenantAdmin, 
          email: email,
        },
      });
      if (!teamsListLoading && teamsListData && teamsListData.getAllTeamsInTermByRole) {
        let rows = [];
        for (const team of teamsListData.getAllTeamsInTermByRole) {
          let row = [];

          const {
            loading: teamTermResourcesLoading,
            error: teamTermResourcesError,
            data: teamTermResourcesData,
          } = await fetchAllTeamTermResources({
            variables: {
              teamTermId: parseInt(team.teamTermId),
            },
          });

          if (!teamTermResourcesLoading &&
              teamTermResourcesData &&
              teamTermResourcesData.getAllMembersInTeamTerm) {

            row["teamId"] = team.teamId.teamId;
            row["teamTermId"] = team.teamTermId;
            row["name"] = team.teamId.name;
            row["noOfResources"] =
              teamTermResourcesData.getAllMembersInTeamTerm.length
              ? teamTermResourcesData.getAllMembersInTeamTerm.length
              : "";
            rows.push(row);
          };
        };
        setTeamsList(rows);
      };
    };
  };

  const getTermData = async () => {
    if (termUuid) {
      // Get term information
      const {
        loading: termDataLoading,
        error: termDataError,
        data: termData,
      } = await getTermDataQuery({
        variables: { termUuid: termUuid },
      });
    if (!termDataLoading && termData && termData.getTermDataByTermUuid)
     {
      setTermData(termData.getTermDataByTermUuid);
      setTermName(termData.getTermDataByTermUuid.name);
      getTermInSprintPeriods();
    }
    };
  };

  const getTermInSprintPeriods = async () => {
    if (termUuid) {
      const {
        loading: loadingTermInSprintPeriods,
        error: errorTermInSprintPeriods,
        data: dataTermInSprintPeriods,
      } = await getTermInSprintPeriodsQuery({
        variables: {
          termUuid: termUuid,
        },
      });

      if (
        !loadingTermInSprintPeriods &&
        dataTermInSprintPeriods &&
        dataTermInSprintPeriods.termAllInSprintPeriodList
      ) {
        setPeriodDataList(
          dataTermInSprintPeriods.termAllInSprintPeriodList
        );
        setLoadData(true);

        if (dataTermInSprintPeriods.termAllInSprintPeriodList.length > 0) {
          const firstPeriodStartDate = new Date(
            dataTermInSprintPeriods.termAllInSprintPeriodList[0].startDate
          );
          setSprintStartDate(firstPeriodStartDate.toLocaleDateString("sv-SE"));

          const lastPeriodEndDate = new Date(
            dataTermInSprintPeriods.termAllInSprintPeriodList.slice(-1)[0].endDate
          );
          setSprintEndDate(lastPeriodEndDate.toLocaleDateString("sv-SE"));
        }
      }
    }
  };

  const getResourcesData = async (teamTermId, teamName) => {
    if (teamTermId) {
      const {
        loading: teamTermResourcesLoading,
        error: teamTermResourcesError,
        data: teamTermResourcesData,
      } = await fetchAllTeamTermResources({
        variables: {
          teamTermId: parseInt(teamTermId),
        },
      });

      if (!teamTermResourcesLoading &&
          teamTermResourcesData &&
          teamTermResourcesData.getAllMembersInTeamTerm.length > 0) {        
        setOpenResourcesDialog({
          members: teamTermResourcesData.getAllMembersInTeamTerm
           ? teamTermResourcesData.getAllMembersInTeamTerm.filter(
            (item) => item.userTypeId.typeName === "Member") : [],
          staff: teamTermResourcesData.getAllMembersInTeamTerm
           ? teamTermResourcesData.getAllMembersInTeamTerm.filter(
            (item) => item.userTypeId.typeName === "Staff") : [],
          teamName: teamName,          
          termName: teamTermResourcesData.getAllMembersInTeamTerm[0].teamTermId.termId.name
        });
      }
    else
    {
      setOpenResourcesDialog({
          members: [],
          staff:  [],
          teamName: teamName,          
          termName: termName
        });
    }
    };
  };

  const getAttendanceData = async (teamId, name, teamTermId) => {
    let teamTermPeriodsEventsData = [];
    let members = [];
    let staff = [];
    if (teamTermId){
      const {
        loading: teamTermPeriodsLoading,
        error: teamTermPeriodsError,
        data: teamTermPeriodsData,
      } = await fetchAllTeamTermPeriods({
        variables: {
          teamTermId: parseInt(teamTermId),
        },
      });

      if (
        !teamTermPeriodsLoading &&
        teamTermPeriodsData &&
        teamTermPeriodsData.teamTermAllPeriodList
      ) teamTermPeriodsEventsData = flattenRows2(
          teamTermPeriodsData.teamTermAllPeriodList);

      const {
        loading: teamTermResourcesLoading,
        error: teamTermResourcesError,
        data: teamTermResourcesData,
      } = await fetchAllTeamTermResources({
        variables: {
          teamTermId: parseInt(teamTermId),
        },
      });

      if (!teamTermResourcesLoading &&
          teamTermResourcesData &&
          teamTermResourcesData.getAllMembersInTeamTerm) {
        members = teamTermResourcesData.getAllMembersInTeamTerm.filter(
          (item) => item.userTypeId.typeName === "Member");
        staff = teamTermResourcesData.getAllMembersInTeamTerm.filter(
          (item) => item.userTypeId.typeName === "Staff");
      };
    };
    setOpenAttendanceDialog({
      members: members,
      staff: staff,
      periodRows: teamTermPeriodsEventsData,
      name,
      teamTermId
    });
  };

  const getTeamTermActivitiesData = async (teamTermId, teamName) => {
    if (teamTermId){
      const {
        loading: teamTermPeriodsLoading,
        error: teamTermPeriodsError,
        data: teamTermPeriodsData,
      } = await fetchAllTeamTermPeriods({
        variables: {
          teamTermId: parseInt(teamTermId),
        },
      });

      if (
        !teamTermPeriodsLoading &&
        teamTermPeriodsData &&
        teamTermPeriodsData.teamTermAllPeriodList
      ) setActivitiesRows(flattenRows(
          teamTermPeriodsData.teamTermAllPeriodList
        )
      );
    };
    setOpenActivitiesDialog(teamName);
  }

  const activitiesColumns = [
    {
      field: "period",
      headerName: "Period",
      headerClassName: "super-app-theme--header",
      minWidth: 130,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        if (params.row.period) {
          return (
            <Typography variant="h2" style={{ paddingTop: 10 }}>
              {params.row.period}
            </Typography>
          );
        } else if (params.row.startDate && params.row.endDate)
          return (
            <Box>
              <Typography variant="h5" className="row-span-empty">
                <b>Start Date:&nbsp;</b>
                {params.row.startDate}
              </Typography>
              <Typography variant="h5" className="row-span-empty">
                <b>End Date:&nbsp;</b>
                {params.row.endDate}
              </Typography>
            </Box>
          );
        return <span className="row-span-empty"></span>;
      },
    },
    {
      field: "event",
      headerClassName: "super-app-theme--header",
      headerName: "Event",
      minWidth: 150,
      sortable: false,
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div>{params.value}</div>;
      },
    },
    {
      field: "desc",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      minWidth: 220,
      sortable: false,
      align: "center",
      flex: 1,
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <StyledTooltip title={params.value}>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
              }}
            >
              {params.value}
            </div>
          </StyledTooltip>
        );
      },
    },
    {
      field: "scheduledDate",
      headerName: "Scheduled Date",
      headerClassName: "super-app-theme--header",
      minWidth: 170,
      sortable: false,
      align: "center",
      //  flex: 1,
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div>{params.value}</div>;
      },
    },
    {
      field: "actualDate",
      headerClassName: "super-app-theme--header",
      headerName: "Actual Date",
      minWidth: 150,
      sortable: false,
      align: "center",
      //  flex: 1,
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div>{params.value}</div>;
      },
    },
  ];

  const periodColumns = [
    {
      field: "name",
      headerName: "Period Name",
      minWidth: 150,
      flex: 1,
      disableColumnMenu: true,
    },
    {
      field: "startDate",
      headerName: "Start Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "endDate",
      headerName: "End Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
  ];

  const teamColumns = [
    {
      field: "name",
      headerName: "Team Name",
      minWidth: 150,
      flex: 1,
      disableColumnMenu: true,
    },
    {
      field: "noOfResources",
      headerName: "No of Resources",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => {
        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <StyledTooltip title="Activities">
              <IconButton style={{ padding: 0 }}>
                <CalendarMonthOutlinedIcon
                  onClick={() => getTeamTermActivitiesData(rows.row.teamTermId, rows.row.name)}
                />
              </IconButton>
            </StyledTooltip>
            <Box pr={2} />
            <StyledTooltip title="Resources">
              <IconButton style={{ padding: 0 }}>
                <Diversity1Icon
                  onClick={() =>
                    getResourcesData(rows.row.teamTermId, rows.row.name)
                  }
                />
              </IconButton>
            </StyledTooltip>
            <Box pr={2} />
            <StyledTooltip title="Attendance">
              <IconButton style={{ padding: 0 }}>
                <HowToRegOutlinedIcon
                onClick={() =>
                  getAttendanceData(
                    rows.row.teamId,
                    rows.row.name,
                    rows.row.teamTermId
                  )
                }
                />
              </IconButton>
            </StyledTooltip>
          </Box>
        );
      },
    },
  ];

  const attendanceColumns = [
    {
      field: "period",
      headerClassName: "super-app-theme--header",
      headerName: "Period",
      minWidth: 150,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "event",
      headerName: "Event",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "eventType",
      headerName: "Event Type",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "description",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "scheduledDate",
      headerClassName: "super-app-theme--header",
      headerName: "Scheduled Date",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "actualDate",
      headerClassName: "super-app-theme--header",
      headerName: "Actual Date",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "attended",
      headerClassName: "super-app-theme--header",
      headerName: "Member Attended?",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
  ];

  const flattenRows = (data) => {
    let rowId = 1;
    let eventRows = [];
    if (data.length === 0) return [];
    data.forEach((period, index) => {
      if (period.teamTermEvents.length > 0 && period.inSprint) {
        period.teamTermEvents.forEach((event, index) => {
          eventRows.push({
            id: rowId++,
            teamTermPeriodId: period.teamTermPeriodId,
            period: index === 0 ? period.name : null, // Only show in the first row
            startDate: index === 1 ? period.startDate : null, // Only show in the secound row
            endDate: index === 1 ? period.endDate : null,
            event: event.name,
            desc: event.desc,
            eventType: event.eventType,
            teamTermEventId: event.teamTermEventId,
            scheduledDate: event.scheduledDate,
            actualDate: event.actualDate,
            attendanceRequired: event.attendanceRequired,
          });
        });
      }
      // For the case that there is not any event under period
      if (period.teamTermEvents.length === 0 && period.inSprint) {
        eventRows.push({
          id: rowId++,
          teamTermPeriodId: null,
          period: period.name,
          startDate: null,
          endDate: null,
          dateRange: null,
          event: null,
          desc: null,
          scheduledDate: "",
          actualDate: "",
        });
      }
    });
    return eventRows;
  };

  const flattenRows2 = (data) => {
    let rowId = 1;
    let eventRows = [];
    if (data.length === 0) return [];
    data.forEach((period, index) => {
      if (period.teamTermEvents.length > 0 && period.inSprint) {
        period.teamTermEvents.forEach((event, index) => {
          if (event.attendanceRequired) {
            eventRows.push({
              id: rowId++,
              teamTermPeriodId: period.teamTermPeriodId,
              period: period.name,
              startDate: period.startDate,
              endDate: period.endDate,
              event: event.name,
              desc: event.desc,
              eventType: event.eventType,
              teamTermEventId: event.teamTermEventId,
              scheduledDate: event.scheduledDate,
              actualDate: event.actualDate,
              attendanceRequired: event.attendanceRequired,
            });
          };
        });
      }
    });
    return eventRows;
  };

  function DataGridTitle() {
    return (
      <Box pt={1}>
        <Typography variant="h1" style={{ fontSize: 18, paddingBottom: 6 }}>
          Sprint Periods
        </Typography>
        <Divider />
      </Box>
    );
  }

  function TeamsDataGridTitle() {
    return (
      <Box pt={1}>
        <Typography variant="h1" style={{ fontSize: 18, paddingBottom: 6 }}>
          Sprint Teams
        </Typography>
        <Divider />
      </Box>
    );
  }
  
  if (loadContent && loadData)
    if (viewAccess)
      return (
        <div className={classes.root}>
          <Header breadcrumbs={[{ label:  `${termData.name}${termData.current ? " (Current Sprint)" : ""}`,
                                  link: null }]} />
          <div className={classes.container}>
            <Box mt={2} mb={2} textAlign="center">
              <Typography
                variant="body1"
                style={{ marginBottom: 10, fontWeight: 600 }}
              >
                Sprint Detail
              </Typography>
            </Box>
            <Divider />
            <Grid container style={{ paddingTop: 20 }}>
              <Grid
                item
                xs={4}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography style={{ paddingRight: 5 }} variant="h2">
                  Sprint Name:
                </Typography>
                <Typography variant="h3">{termName}</Typography>
              </Grid>
              <Grid
                item
                xs={4}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography style={{ paddingRight: 5 }} variant="h2">
                  Sprint Start Date:
                </Typography>
                {sprintStartDate && (
                  <Typography variant="h3">
                    {dayFormat(sprintStartDate.substring(0, 10), "monthDDYYYY")}
                  </Typography>
                )}
              </Grid>
              <Grid
                item
                xs={4}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Typography style={{ paddingRight: 5 }} variant="h2">
                  Sprint End Date:
                </Typography>
                {sprintEndDate && (
                  <Typography variant="h3">
                    {dayFormat(sprintEndDate.substring(0, 10), "monthDDYYYY")}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Grid
              container
              spacing={3}
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Grid item md={6}>
                <Box pt={4}>
                  <DataGrid
                    className={classes.dataGridStyle}
                    columns={periodColumns}
                    rows={periodDataList}
                    showCellRightBorder={true}
                    hideFooter={true}
                    autoWidth={true}
                    autoHeight={true}
                    slots={{
                      toolbar: DataGridTitle,
                    }}
                    rowHeight={40}
                    getRowId={(row) => row.periodId}
                  />
                </Box>
              </Grid>
              <Grid item md={6}>
                <Box pt={4}>
                  <DataGrid
                    className={classes.dataGridStyle}
                    columns={teamColumns}
                    rows={teamsList}
                    showCellRightBorder={true}
                    hideFooter={true}
                    autoWidth={true}
                    autoHeight={true}
                    slots={{
                      toolbar: TeamsDataGridTitle,
                    }}
                    getRowId={(row) => row.teamId}
                    rowHeight={40}
                  />
                </Box>
              </Grid>
            </Grid>
            {openActivitiesDialog && (
              <ActivitiesDialog
                name={openActivitiesDialog}
                columns={activitiesColumns}
                rows={activitiesRows}
                closeDialog={() => setOpenActivitiesDialog(false)}
              />
            )}
            {openResourcesDialog && (
              <ResourcesDialog
                teamName={openResourcesDialog.teamName}
                termName={openResourcesDialog.termName}
                members={openResourcesDialog.members}
                staff={openResourcesDialog.staff}
                closeDialog={() => setOpenResourcesDialog(null)}
              />
            )}
            {openAttendanceDialog && (
              <MemberAttendanceInfoDialog
                teamTerm={openAttendanceDialog.name}
                membersList={openAttendanceDialog.members}
                staffList={openAttendanceDialog.staff}
                teamTermPeriodEvents={openAttendanceDialog.periodRows}
                closeDialog={() => setOpenAttendanceDialog(null)}
              />
            )}
          </div>
        </div>
      );
    else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );

}
export default SprintDetail;
